module.exports = __webpack_public_path__ + "static/media/tara_with_jama.c50aa506.svg";